import {axios, HOST, config} from './settiing';

export default {
  addCenterOperTime(data) {
    return axios.post(`${HOST}/resource/center/time`, data, config);
  },
  getCenterOperTime(centerId) {
    return axios.get(`${HOST}/resource/center/time/${centerId}`, config);
  },
  updateCenterOperTime(data) {
    return axios.put(`${HOST}/resource/center/time`, data, config);
  }
}